import { slideshowStyles } from "@insite/content-library/Widgets/Basic/Slideshow";
import { css } from "styled-components";

Object.assign(slideshowStyles, {
    dotButton: {
        css: css`
            ${slideshowStyles.dotButton?.css}
            min-height: 0;
        `,
    },
});
